import {
  InstagramIcon,
  LinkedInIcon,
  TelegramIcon,
  TwitterIcon,
  FaceBookIcon,
  MailIcon,
} from "assets/icons";
import { Link } from "react-router-dom";

export function Footer() {
  const socialsLinks = [
    {
      icon: <LinkedInIcon />,
      link: "/",
    },
    {
      icon: <TelegramIcon />,
      link: "/",
    },
    {
      icon: <TwitterIcon />,
      link: "/",
    },
    {
      icon: <FaceBookIcon />,
      link: "/",
    },
    {
      icon: <InstagramIcon />,
      link: "/",
    },
  ];

  const paymentMethods = [
    {
      label: "Visa",
      image: "/images/visa.svg",
    },
    {
      label: "Mastercard",
      image: "/images/mastercard.svg",
    },
    {
      label: "Paypal",
      image: "/images/paypal.svg",
    },
  ];

  const quickLinks = [
    {
      label: "Home",
      link: "/",
    },
    {
      label: "Book Tickes",
      link: "/",
    },
    {
      label: "Promotions",
      link: "/",
    },
    {
      label: "Contact Us",
      link: "/",
    },
  ];

  return (
    <div className="w-full flex justify-center bg-[#F8F8F8]">
      <div className="w-full max-w-8xl margins flex gap-16 py-12">
        <div className="flex-1 flex flex-col gap-6">
          <Link to="/">
            <img src="/images/logo.jpeg" alt="logo" className="h-[64px]" />
          </Link>
          <div className="text-base leading-[30px] text-black mb-5">
            Maraliner is dedicated to providing safe, reliable, and affordable
            bus services across Malaysia. With a modern fleet and a commitment
            to customer satisfaction, we make every journey a pleasant
            experience.
          </div>

          <div className="w-full flex items-center gap-6">
            {socialsLinks.map((item, index) => (
              <Link key={index} to={item.link} className="text-primary-700">
                {item.icon}
              </Link>
            ))}
          </div>
        </div>

        <div className="flex-1 flex flex-col">
          <div className="flex flex-col gap-4 mb-[90px]">
            <div className="text-base font-semibold text-black">Contact</div>
            <div className="text-base text-black">Phone No: 03-12345678</div>
            <div className="text-base text-black">
              Email: contact@maraliner.com
            </div>
            <div className="text-base text-black">
              Address: ABC, Maraliner HQ, 50450 Kuala Lumpur Malaysia
            </div>
          </div>
          <div className="flex items-center gap-4">
            {paymentMethods.map((item, index) => (
              <div
                key={index}
                className="w-[90px] h-[48px] border-[1px] border-[#D9D9D9] rounded-[4px] flex items-center justify-center"
              >
                <img src={item.image} alt={item.label} />
              </div>
            ))}
          </div>
        </div>

        <div className="flex-1 flex flex-col">
          <div className="text-base font-semibold text-black mb-4">
            Quick Link
          </div>
          <div className="flex flex-col gap-4 mb-[44px]">
            {quickLinks.map((item, index) => (
              <Link key={index} to={item.link} className="text-base text-black">
                {item.label}
              </Link>
            ))}
          </div>
          <div className="flex flex-col">
            <div className="text-base text-black mb-1">Email</div>
            <div className="flex items-center bg-white border-[0.5px] rounded-[4px] overflow-hidden">
              <div className="px-2 flex items-center flex-1 ">
                <span className="text-[#A6A6A6] mr-4">
                  <MailIcon />
                </span>
                <input
                  placeholder="enter yout email"
                  className="text-base text-black"
                />
              </div>
              <button className="text-sm text-white font-medium  bg-primary-700 h-[48px] py-2 px-4">
                Subscription
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
